// src/pages/HomePage.js
/**
 * Home dashboard shown **after a successful sign-in**.
 *
 * Purpose ──────────────────────────────────────────────────────────
 *  • Acts as a hub for everything the authenticated user can do:
 *      – **New Assessment**  → starts the recording workflow.
 *      – **Questionnaires**  → opens the questionnaire picker.
 *      – **Results**         → (future) list of historical results.
 *
 *  • Keeps the UI deliberately sparse so it loads instantly even on
 *    slow networks (no heavy dependencies, no remote calls).
 *
 * UX / visual layout ───────────────────────────────────────────────
 *  • Tailwind `home-button` utility handles colours / hover states
 *    (defined in `index.css`).
 *  • “New Assessment” icon = filled-in video-camera glyph.
 *
 * @returns {JSX.Element}
 */

import React, { memo } from "react";
import { Link } from "react-router-dom";

/* ------------------------------------------------------------------ */
/* Component                                                          */
/* ------------------------------------------------------------------ */
function HomePage() {
  /* No local state or effects needed. Purely presentational. */
  return (
    <div className="w-full max-w-lg h-full p-4 flex flex-col justify-end md:justify-start items-center gap-4">
      <div className="w-full grid grid-flow-row grid-cols-2 gap-4">
        {/* Top-row buttons */}
        <Link to="/questionnaires" className="home-button col-span-2">
          Questionnaires
        </Link>

        {/* <Link to="/results" className="home-button">
          Results
        </Link> */}

        {/* Full-width CTA */}
        <Link
          to="/review-metadata"
          className="home-button flex flex-col col-span-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 -960 960 960"
            className="h-24 fill-greyscale-1"
            aria-hidden="true"
          >
            <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h480q33 0 56.5 23.5T720-720v180l160-160v440L720-420v180q0 33-23.5 56.5T640-160z" />
          </svg>
          <p className="subtitle-text">New&nbsp;Assessment</p>
        </Link>
      </div>
    </div>
  );
}

export default memo(HomePage);
